import { Routes } from '@angular/router';
import { ContentComponent } from './components/content/content.component';
import { LoginPageComponent } from './auth/login/login-page.component';
import { authChildGuard } from './auth/auth.guard';
import { childRoutes } from './routes/childRoutes';
import { RoutesEnum } from '../utils/enums/routes.enum';

export const routes: Routes = [
  { path: RoutesEnum.Login, component: LoginPageComponent },
  {
    path: '',
    component: ContentComponent,
    canActivateChild: [authChildGuard],
    children: childRoutes,
  },
];
